import type { DemoScenarioResolved } from 'tio-data/demo/types';
import type { DemoFixtureIdentity, DemoProductConfig, DemoScenario } from 'tio-employee/demo/types';
import {
  buildContributionsFetchMatchers,
  buildContributionsMatchers,
} from 'tio-employee/demo/products/contributions-fixtures';

/**
 * Contributions demo builder — employer student-loan contributions (SLR). Serves
 * the contribution payment timeline (accounting-transaction reads), the
 * SLR-eligible employee (with plan), and the raw SLR limits / future-payments /
 * alerts endpoints. See contributions-fixtures.ts for the data + the re-root note.
 * Employer/employee names derive from the shared fixture identity.
 */
export function buildContributionsDemo(
  config: Extract<DemoProductConfig, { kind: 'contributions' }>,
  _scenario: DemoScenario,
  identity: DemoFixtureIdentity
): DemoScenarioResolved {
  if (config.scenarioId === 'in-progress') {
    return {
      matchers: buildContributionsMatchers(identity),
      seed: [],
      fetchMatchers: buildContributionsFetchMatchers(),
    };
  }
  return { matchers: [], seed: [] };
}
